export enum SKELETON_TYPE_MAP {
    BOX = 'skeleton-loader--box',
    CIRCLE = 'skeleton-loader--circle',
    TEXT = 'skeleton-loader--text',
    SQUARE = 'skeleton-loader--square',
}
